import axios from "axios";
import { API_URL } from "./conection";

export const createBugReport = async (data) => {
  const res = await axios.post(`${API_URL}/bug-reports`, data);
  return res.data;
};
